import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AddProduct from "./AddProduct";
import { theme } from "../Theme";

export default function ProductView({ open, row, handleClose, category }) {
  // const [open, setOpen] = React.useState(true);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  const content = () => (
    <Box sx={{ p: 5 }}>
      <Box sx={{ width: "35vw" }} role="presentation">
        <AddProduct state={row} handleClose={handleClose} category={category} />
      </Box>
    </Box>
  );

  return (
    <div>
      <React.Fragment>
        {/* <Button onClick={handleOpen}>Right</Button> */}
        <Drawer
          anchor="right"
          open={open}
          onClose={handleClose}
          sx={{ zIndex: theme.zIndex.drawer + 1 }}
        >
          {content()}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
